// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forget-container {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 20px;
  background: white;
  height: 100vh;
}
.forget-container .forget-password-container {
  width: 40%;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  height: fit-content;
  background-color: ghostwhite;
}
.forget-container .forget-password-container .select-input-wrapper {
  position: relative;
  width: 100%;
  margin-top: 20px;
}
.forget-container .forget-password-container .select-input-wrapper .country-label,
.forget-container .forget-password-container .select-input-wrapper .language-label {
  position: absolute;
  top: -10px;
  left: 14px;
  z-index: 999;
}
.forget-container .forget-password-container .select-input-wrapper input,
.forget-container .forget-password-container .select-input-wrapper select {
  width: 100%;
  outline: none;
  height: 50px;
}
.forget-container .reset-text {
  margin-top: 5%;
  margin-bottom: 20px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 1.5rem;
  color: #0C3688;
}
.forget-container .forget-password-container p {
  font-size: 12px;
  margin-bottom: 55px;
}
.forget-container .form-submit {
  margin-top: 60px;
}
.forget-container .error-message {
  color: red;
  margin-bottom: 16px;
}
.forget-container .submit_btn {
  padding: 10px 15px;
  border: none;
  cursor: pointer;
  margin-top: 53px;
  width: auto;
  height: 50px;
  border-radius: 5px;
  background: linear-gradient(277.62deg, #0C3688 10%, #2057C2 84.88%);
  font-family: "Poppins";
  font-size: 13px;
  color: #ffffff;
}
.forget-container .submit_btn:disabled {
  cursor: not-allowed;
}

@media screen and (max-width: 900px) {
  .forget-container .forget-password-container {
    width: 50%;
    margin: 0 auto;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    text-align: center;
    height: auto !important;
    background-color: ghostwhite;
  }
}
@media screen and (max-width: 648px) {
  .forget-container .forget-password-container {
    width: auto !important;
    margin: 0 auto;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    text-align: center;
    height: auto !important;
    background-color: ghostwhite;
  }
}
@media screen and (max-width: 480px) {
  .forget-container {
    padding: 5px;
  }
}`, "",{"version":3,"sources":["webpack://./src/component/forgetpassword/forgetpassword.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;AACF;AACE;EACE,UAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;EACA,mBAAA;EACA,4BAAA;AACJ;AACI;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AACN;AACM;;EAEE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;AACR;AAEM;;EAEE,WAAA;EACA,aAAA;EACA,YAAA;AAAR;AAKE;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAHJ;AAME;EACE,eAAA;EACA,mBAAA;AAJJ;AAOE;EACE,gBAAA;AALJ;AAeE;EACE,UAAA;EACA,mBAAA;AAbJ;AAgBE;EACE,kBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mEAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;AAdJ;AAiBE;EACE,mBAAA;AAfJ;;AAmBA;EACE;IACE,UAAA;IACA,cAAA;IACA,aAAA;IACA,sBAAA;IACA,kBAAA;IACA,uCAAA;IACA,kBAAA;IACA,uBAAA;IACA,4BAAA;EAhBF;AACF;AAmBA;EACE;IACE,sBAAA;IACA,cAAA;IACA,aAAA;IACA,sBAAA;IACA,kBAAA;IACA,uCAAA;IACA,kBAAA;IACA,uBAAA;IACA,4BAAA;EAjBF;AACF;AAoBE;EACE;IACE,YAAA;EAlBJ;AACF","sourcesContent":[".forget-container {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  padding: 20px;\r\n  background: white;\r\n  height: 100vh;\r\n\r\n  .forget-password-container {\r\n    width: 40%;\r\n    margin: 0 auto;\r\n    padding: 20px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n    text-align: center;\r\n    height: fit-content;\r\n    background-color: ghostwhite;\r\n\r\n    .select-input-wrapper {\r\n      position: relative;\r\n      width: 100%;\r\n      margin-top: 20px;\r\n\r\n      .country-label,\r\n      .language-label {\r\n        position: absolute;\r\n        top: -10px;\r\n        left: 14px;\r\n        z-index: 999;\r\n      }\r\n\r\n      input,\r\n      select {\r\n        width: 100%;\r\n        outline: none;\r\n        height: 50px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .reset-text {\r\n    margin-top: 5%;\r\n    margin-bottom: 20px;\r\n    font-family: \"Nunito\";\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 1.5rem;\r\n    color: #0C3688;\r\n  }\r\n\r\n  .forget-password-container p {\r\n    font-size: 12px;\r\n    margin-bottom: 55px;\r\n  }\r\n\r\n  .form-submit {\r\n    margin-top: 60px;\r\n  }\r\n\r\n  // input {\r\n  //   width: 95%;\r\n  //   padding: 8px;\r\n  //   margin-bottom: 16px;\r\n  //   border-radius: 5px;\r\n  // }\r\n\r\n  .error-message {\r\n    color: red;\r\n    margin-bottom: 16px;\r\n  }\r\n\r\n  .submit_btn {\r\n    padding: 10px 15px;\r\n    border: none;\r\n    cursor: pointer;\r\n    margin-top: 53px;\r\n    width: auto;\r\n    height: 50px;\r\n    border-radius: 5px;\r\n    background: linear-gradient(277.62deg, #0C3688 10%, #2057C2 84.88%);\r\n    font-family: \"Poppins\";\r\n    font-size: 13px;\r\n    color: #ffffff;\r\n  }\r\n\r\n  .submit_btn:disabled {\r\n    cursor: not-allowed;\r\n  }\r\n}\r\n\r\n@media screen and (max-width:900px) {\r\n  .forget-container .forget-password-container {\r\n    width: 50%;\r\n    margin: 0 auto;\r\n    padding: 20px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n    text-align: center;\r\n    height: auto !important;\r\n    background-color: ghostwhite;\r\n  }\r\n}\r\n\r\n@media screen and (max-width:648px) {\r\n  .forget-container .forget-password-container {\r\n    width: auto !important;\r\n    margin: 0 auto;\r\n    padding: 20px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n    text-align: center;\r\n    height: auto !important;\r\n    background-color: ghostwhite;\r\n  }\r\n}\r\n\r\n  @media screen and (max-width:480px) {\r\n    .forget-container {\r\n      padding: 5px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
